import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';

const AlphabeticalList = (props) => {
  const firstLetter = useRef();

  const enterHandler = (e) => {
    if (e.keyCode === 13) {
      props.returnToAlphabeticListHandler();
    }
  };

    useEffect(() => {
    firstLetter?.current?.focus();
  }, [props.modalIsOpen, props.alphabeticalListActive]);

  const { list, currentActiveLetter } = props;

  const listItems = list.map((letter, index) => (
    <li
      key={`${index}--${letter.Key}`}
      className={classNames({
        'categories-alphabetical-list__item': true,
        'categories-alphabetical-list__item--is-active':
          currentActiveLetter === letter.Key,
      })}
    >
      <a
        onKeyDown={(e) => enterHandler(e)}
        ref={letter.Key === 'a' ? firstLetter : null}
        href={`#${letter.Key}`}
      >
        {letter.Key.toUpperCase()}
      </a>
    </li>
  ));

  return <ul className="categories-alphabetical-list">{listItems}</ul>;
};

export default AlphabeticalList;
